import React from 'react';
import { CustomTextField } from '../../../../../components/CustomTextField';
import DividerWithText from '../../../../../components/DividerWithText';
import CustomFieldsTable from "./CustomFieldsTable";
import {useTranslation} from "react-i18next";
/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 * @component VisitorTypeForm
 * @description React component that renders the visitor type form,
 *              including input for the visitor type name and
 *              the custom fields table component.
 *
 * @param {Object} item - Visitor type data model.
 * @param {function} handleChange - Handler for input changes.
 * @param {boolean} emptyFields - Flag to indicate empty field validation.
 * @param {Array} fields - List of custom fields.
 * @param {function} setFields - Setter for the custom fields list.
 * @param {Object} fieldData - Current custom field data.
 * @param {function} setFieldData - Setter for the current custom field data.
 * @param {boolean} disabled - Flag that renders the form as read only.
 *
 * @returns {JSX.Element} Rendered VisitorTypeForm component.
 */
const VisitorTypeForm = ({item, handleChange, emptyFields, fields, setFields, fieldData, setFieldData, disabled = false}) => {
    const {t} = useTranslation();

    return (
        <>
            <div className='row'>
                <div className={'col-12 my-4'}>
                    <DividerWithText title={t('data')} />
                </div>
                <div className='col-12'>
                    <CustomTextField
                        id={'txt_vtf_name'}
                        name={"name"}
                        value={item?.name}
                        trans={'name'}
                        type={'text'}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />
                </div>

                <CustomFieldsTable
                    emptyFields={emptyFields}
                    fields={fields}
                    setFields={setFields}
                    fieldData={fieldData}
                    setFieldData={setFieldData}
                    disabled={disabled}
                />
            </div>
        </>
    );
};
export default VisitorTypeForm;
